/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_REC_EMPLOYER_CONTRIB_ITEM = {
  id: 'employer_contrib_sidebar',
  screenId: 'lab-rec-employer-contrib',
  label: 'Contrib. patronales',
  description: 'Aportes y cargas que calcula el sistema al liquidar.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Definís los conceptos patronales que el sistema suma automáticamente al generar cada recibo: aportes SIPA, obra social, ART, sindicato, etc. También podés agregar otros costos del convenio.',
      },
      {
        title: 'Lista',
        bullets: [
          'Interruptor «Solo conceptos activos» — activo por defecto.',
          'Columnas: Código, Descripción, Rubro, Cálculo, Base, Valor, Origen (Sistema / Usuario), Activo.',
          'Tocá una fila para editar. Botón + para concepto nuevo.',
        ],
      },
      {
        title: 'Alta / edición de concepto',
        fields: [
          { label: 'Código / Descripción', description: 'Identificador interno y nombre. Obligatorios.' },
          {
            label: 'Rubro',
            description: 'Sindical, Seguridad social, Obra social, INSSJP/PAMI, ART, Cámaras/asociaciones u Otros.',
          },
          {
            label: 'Forma de cálculo',
            description: 'Porcentaje sobre una base (básico o total remunerativo) o importe fijo.',
          },
          { label: 'Valor', description: '% (ej. 20,4) o importe fijo en pesos, según la forma elegida.' },
          { label: 'Activo', description: 'Solo en edición. Desactivá conceptos que ya no apliquen.' },
        ],
      },
      {
        title: 'Conceptos del sistema',
        paragraphs: [
          'Algunos vienen precargados (Origen «Sistema»). En esos casos no podés cambiar código, descripción, rubro ni forma de cálculo; sí el valor y si está activo.',
        ],
      },
      {
        title: 'Dónde se ven',
        paragraphs: [
          'Al liquidar un recibo, las contribuciones aparecen en el detalle por rubro y en el gráfico de costo laboral. No se pagan al empleado: son costo para la empresa.',
        ],
      },
    ],
  },
}
